import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function QuoteModal({ open, onOpenChange, productName }) {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: "", company: "", phone: "", email: "", city: "",
    quantity: "", unit: "Kilogram", details: ""
  });

  const update = (k, v) => setForm({ ...form, [k]: v });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("Please fill in your name and phone number");
      return;
    }
    // Save to localStorage as mock backend
    const existing = JSON.parse(localStorage.getItem("fss_inquiries") || "[]");
    existing.push({ ...form, product: productName || "General Inquiry", at: new Date().toISOString() });
    localStorage.setItem("fss_inquiries", JSON.stringify(existing));
    setSubmitted(true);
    toast.success("Thank you! Inquiry received.");
  };

  const close = () => {
    onOpenChange(false);
    setTimeout(() => {
      setSubmitted(false);
      setForm({ name: "", company: "", phone: "", email: "", city: "", quantity: "", unit: "Kilogram", details: "" });
    }, 300);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => (o ? onOpenChange(true) : close())}>
      <DialogContent className="sm:max-w-[560px] max-h-[90vh] overflow-y-auto">
        {!submitted ? (
          <>
            <DialogHeader>
              <DialogTitle className="text-brand-navy text-xl">Tell us about your requirement</DialogTitle>
              <DialogDescription className="text-sm">
                {productName ? `Inquiry for: ${productName}` : "Submit your details and our team will contact you shortly."}
              </DialogDescription>
            </DialogHeader>
            <form onSubmit={handleSubmit} className="space-y-3 mt-2">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label className="text-xs font-medium text-brand-navy">Quantity</label>
                  <Input value={form.quantity} onChange={(e) => update("quantity", e.target.value)} placeholder="e.g. 500" />
                </div>
                <div>
                  <label className="text-xs font-medium text-brand-navy">Unit</label>
                  <select value={form.unit} onChange={(e) => update("unit", e.target.value)} className="w-full h-10 rounded-md border border-input bg-background px-3 text-sm">
                    <option>Kilogram</option><option>Piece</option><option>Roll</option><option>Sheet</option><option>Meter</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="text-xs font-medium text-brand-navy">Additional detail</label>
                <Textarea value={form.details} onChange={(e) => update("details", e.target.value)} placeholder="Specifications, density, thickness, dimensions, etc." rows={3} />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <Input value={form.name} onChange={(e) => update("name", e.target.value)} placeholder="Name *" required />
                <Input value={form.company} onChange={(e) => update("company", e.target.value)} placeholder="Company Name" />
                <Input value={form.phone} onChange={(e) => update("phone", e.target.value)} placeholder="Phone Number *" required />
                <Input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} placeholder="Email Id" />
                <Input value={form.city} onChange={(e) => update("city", e.target.value)} placeholder="City / State" className="md:col-span-2" />
              </div>
              <Button type="submit" className="w-full btn-red-brand h-11 text-base font-semibold">
                Confirm Your Requirement
              </Button>
            </form>
          </>
        ) : (
          <div className="py-8 flex flex-col items-center text-center">
            <CheckCircle2 size={56} className="text-green-600 mb-3" />
            <h3 className="text-2xl font-bold text-brand-navy">You’re Done!</h3>
            <p className="text-sm text-gray-600 mt-2 max-w-sm">
              We have received your requirements and will reply shortly with the best price.
            </p>
            <p className="text-xs text-gray-500 mt-3">
              For an immediate response, please call <a href="tel:08045812817" className="text-brand-red font-semibold">+91 80458 12817</a>
            </p>
            <Button onClick={close} className="mt-6 btn-primary-brand">Close</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
